'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

const NAV_LINKS = [
  { href: '/subhaal/masjid-al-ihsan', label: 'Home' },
  { href: '/subhaal/masjid-al-ihsan/about-imam', label: 'Imam Madyun' },
  { href: '/subhaal/masjid-al-ihsan/services', label: 'Services' },
  { href: '/subhaal/masjid-al-ihsan/events', label: 'Events' },
  { href: '/subhaal/masjid-al-ihsan/media', label: 'Media' },
  { href: '/subhaal/masjid-al-ihsan/iiua', label: 'IIUA' },
  { href: '/subhaal/masjid-al-ihsan/announcements', label: 'Announcements' },
  { href: '/subhaal/masjid-al-ihsan/resource-guide', label: 'Resource Guide' },
  { href: '/subhaal/masjid-al-ihsan/contact', label: 'Contact' },
];

export default function MasjidHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Amiri:wght@400;700&display=swap');
        .mih-header {
          position: fixed;
          top: 0; left: 0; right: 0;
          z-index: 100;
          transition: background 0.3s, border-color 0.3s, backdrop-filter 0.3s;
          background: rgba(6,13,18,0.0);
          border-bottom: 1px solid transparent;
        }
        .mih-header.scrolled {
          background: rgba(6,13,18,0.92);
          border-bottom-color: rgba(255,255,255,0.06);
          backdrop-filter: blur(16px);
        }
        .mih-header-inner {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 32px;
          height: 68px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
        }
        .mih-header-logo {
          display: flex;
          flex-direction: column;
          gap: 1px;
          text-decoration: none;
          flex-shrink: 0;
        }
        .mih-header-logo:focus-visible {
          outline: 2px solid rgba(212,175,55,0.85);
          outline-offset: 4px;
        }
        .mih-header-logo-ar {
          font-family: 'Amiri', serif;
          font-size: 15px;
          color: rgba(255,255,255,0.7);
          direction: rtl;
          line-height: 1;
        }
        .mih-header-logo-en {
          font-family: monospace;
          font-size: 8px;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
        }
        .mih-header-nav {
          display: flex;
          align-items: center;
          gap: 0;
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .mih-header-nav-link {
          font-family: monospace;
          font-size: 9px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
          text-decoration: none;
          padding: 8px 14px;
          transition: color 0.2s;
          white-space: nowrap;
          display: block;
        }
        .mih-header-nav-link:hover { color: rgba(255,255,255,0.85); }
        .mih-header-nav-link:focus-visible {
          outline: 2px solid rgba(212,175,55,0.85);
          outline-offset: 2px;
          color: rgba(255,255,255,0.85);
        }
        .mih-header-donate {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 18px;
          background: rgba(37,99,235,0.15);
          border: 1px solid rgba(37,99,235,0.35);
          color: rgba(147,197,253,0.9);
          font-family: monospace;
          font-size: 9px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          transition: all 0.2s;
          flex-shrink: 0;
        }
        .mih-header-donate:hover {
          background: rgba(37,99,235,0.25);
          border-color: rgba(37,99,235,0.55);
        }
        .mih-header-donate:focus-visible {
          outline: 2px solid rgba(212,175,55,0.85);
          outline-offset: 3px;
        }
        .mih-header-subhaal {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border: 1px solid rgba(255,255,255,0.08);
          margin-right: 8px;
          flex-shrink: 0;
        }
        .mih-header-subhaal-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #3b82f6;
        }
        .mih-header-subhaal-text {
          font-family: monospace;
          font-size: 7px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.25);
        }
        .mih-header-mobile-btn {
          display: none;
          background: none;
          border: 1px solid rgba(255,255,255,0.12);
          color: rgba(255,255,255,0.6);
          padding: 8px 12px;
          cursor: pointer;
          font-family: monospace;
          font-size: 10px;
          letter-spacing: 0.1em;
          transition: all 0.2s;
        }
        .mih-header-mobile-btn:hover { border-color: rgba(255,255,255,0.25); color: #fff; }
        .mih-header-mobile-btn:focus-visible {
          outline: 2px solid rgba(212,175,55,0.85);
          outline-offset: 3px;
        }
        .mih-mobile-drawer {
          position: fixed;
          top: 68px; left: 0; right: 0;
          background: rgba(6,13,18,0.97);
          border-bottom: 1px solid rgba(255,255,255,0.06);
          backdrop-filter: blur(20px);
          z-index: 99;
          padding: 16px 0;
          transform: translateY(-100%);
          opacity: 0;
          transition: transform 0.3s ease, opacity 0.3s ease;
          pointer-events: none;
        }
        .mih-mobile-drawer.open {
          transform: translateY(0);
          opacity: 1;
          pointer-events: auto;
        }
        .mih-mobile-nav-link {
          display: block;
          font-family: monospace;
          font-size: 10px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.5);
          text-decoration: none;
          padding: 14px 32px;
          border-bottom: 1px solid rgba(255,255,255,0.04);
          transition: color 0.2s, background 0.2s;
        }
        .mih-mobile-nav-link:hover { color: #fff; background: rgba(255,255,255,0.03); }
        .mih-mobile-nav-link:focus-visible {
          outline: 2px solid rgba(212,175,55,0.85);
          outline-offset: -2px;
          color: #fff;
        }

        /* Skip link */
        .mih-header-skip {
          position: absolute;
          left: -9999px;
          top: auto;
          width: 1px;
          height: 1px;
          overflow: hidden;
          background: #1e3a8a;
          color: #fff;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          padding: 10px 20px;
          text-decoration: none;
          border: 2px solid rgba(212,175,55,0.8);
          white-space: nowrap;
          z-index: 200;
        }
        .mih-header-skip:focus {
          position: fixed;
          top: 8px;
          left: 8px;
          width: auto;
          height: auto;
          overflow: visible;
          outline: 3px solid rgba(212,175,55,0.9);
          outline-offset: 2px;
        }

        @media (max-width: 900px) {
          .mih-header-nav { display: none; }
          .mih-header-mobile-btn { display: block; }
          .mih-header-subhaal { display: none; }
          .mih-header-inner { padding: 0 20px; }
        }
      `}</style>

      {/* Skip Navigation */}
      <a href="#main-content" className="mih-header-skip">Skip to main content</a>

      <header className={`mih-header ${scrolled ? 'scrolled' : ''}`} role="banner">
        <div className="mih-header-inner">
          <Link href="/subhaal/masjid-al-ihsan" className="mih-header-logo" aria-label="Masjid Al-Ihsan — Home">
            <span className="mih-header-logo-ar" lang="ar">مَسْجِد الإِحْسَان</span>
            <span className="mih-header-logo-en">Masjid Al-Ihsan · Bronzeville</span>
          </Link>

          <nav aria-label="Main navigation">
            <ul className="mih-header-nav" role="list">
              {NAV_LINKS?.map(link => (
                <li key={link?.href} role="listitem">
                  <Link href={link?.href} className="mih-header-nav-link">{link?.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div className="mih-header-subhaal" aria-hidden="true">
              <div className="mih-header-subhaal-dot" />
              <span className="mih-header-subhaal-text">Haal Project Subhaal</span>
            </div>
            <a
              href="https://www.paypal.com/donate/?hosted_button_id=77VKUXARNLLHJ"
              target="_blank"
              rel="noopener noreferrer"
              className="mih-header-donate"
              aria-label="Donate to Masjid Al-Ihsan (opens in new tab)"
            >
              ◈ Donate
            </a>
            <button
              className="mih-header-mobile-btn"
              onClick={() => setMobileOpen(o => !o)}
              aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={mobileOpen}
              aria-controls="mih-mobile-nav"
            >
              {mobileOpen ? '✕' : '≡'}
            </button>
          </div>
        </div>
      </header>

      <div
        id="mih-mobile-nav"
        className={`mih-mobile-drawer ${mobileOpen ? 'open' : ''}`}
        role="navigation"
        aria-label="Mobile navigation"
        aria-hidden={!mobileOpen}
      >
        {NAV_LINKS?.map(link => (
          <Link key={link?.href} href={link?.href} className="mih-mobile-nav-link" onClick={() => setMobileOpen(false)}>
            {link?.label}
          </Link>
        ))}
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=77VKUXARNLLHJ"
          target="_blank"
          rel="noopener noreferrer"
          className="mih-mobile-nav-link"
          style={{ color: 'rgba(147,197,253,0.8)' }}
          aria-label="Donate to Masjid Al-Ihsan (opens in new tab)"
        >
          ◈ Donate
        </a>
        <Link href="/subhaal" className="mih-mobile-nav-link" style={{ color: 'rgba(255,255,255,0.2)', fontSize: 8 }}>
          ← Haal Project Subhaals
        </Link>
      </div>
    </>
  );
}
